import { hasExactly, intWithin, isPlainRecord, marketRuleSetting, resolveMarketRule } from './market-rule-kit.js';
export const RIDER_SEND_PAYMENT_KEY = 'send.riderPayment';
export const RIDER_SEND_SEARCH_KEY = 'send.riderSearch';
/** Who hands the courier the cash of a rider Send. */
export const RIDER_SEND_PAYERS = ['SENDER_AT_PICKUP', 'RECIPIENT_AT_DROPOFF'];
export const isRiderSendPayer = (v) => typeof v === 'string' && RIDER_SEND_PAYERS.includes(v);
/** An unset market offers no rider Send (fail closed). */
export const DEFAULT_RIDER_SEND_PAYMENT = { allowed: [], default: null };
/** An unreadable version: no rider Send. */
export const STRICT_RIDER_SEND_PAYMENT = { allowed: [], default: null };
export const RIDER_SEND_SEARCH_BOUNDS = { timeoutSeconds: { min: 60, max: 3_600 } };
/** Five minutes of searching before the platform gives up and tells the rider. */
export const DEFAULT_RIDER_SEND_SEARCH = { timeoutSeconds: 300 };
/** An unreadable version: the shortest search (the rider is never left waiting past the bounds). */
export const STRICT_RIDER_SEND_SEARCH = { timeoutSeconds: RIDER_SEND_SEARCH_BOUNDS.timeoutSeconds.min };
export const RIDER_SEND_PAYMENT_REASON_CODES = ['RIDER_SEND_PAYMENT_POLICY_GOVERNED', 'RIDER_SEND_PAYMENT_POLICY_DEFAULT', 'RIDER_SEND_PAYMENT_POLICY_INVALID'];
export const RIDER_SEND_SEARCH_REASON_CODES = ['RIDER_SEND_SEARCH_POLICY_GOVERNED', 'RIDER_SEND_SEARCH_POLICY_DEFAULT', 'RIDER_SEND_SEARCH_POLICY_INVALID'];
/** The stable issue of a value that is not a `send.riderPayment` value, or undefined when it is one. */
export function riderSendPaymentIssue(v) {
    if (!isPlainRecord(v))
        return 'NOT_AN_OBJECT';
    if (!hasExactly(v, ['allowed', 'default']))
        return 'UNKNOWN_OR_MISSING_MEMBER';
    const allowed = v.allowed;
    if (!Array.isArray(allowed) || allowed.length > RIDER_SEND_PAYERS.length || !allowed.every(isRiderSendPayer))
        return 'INVALID_ALLOWED';
    if (new Set(allowed).size !== allowed.length)
        return 'DUPLICATE_ALLOWED';
    if (allowed.length === 0)
        return v.default === null ? undefined : 'INVALID_DEFAULT';
    return isRiderSendPayer(v.default) && allowed.includes(v.default) ? undefined : 'INVALID_DEFAULT';
}
/** The stable issue of a value that is not a `send.riderSearch` value, or undefined when it is one. */
export function riderSendSearchIssue(v) {
    if (!isPlainRecord(v))
        return 'NOT_AN_OBJECT';
    if (!hasExactly(v, ['timeoutSeconds']))
        return 'UNKNOWN_OR_MISSING_MEMBER';
    const b = RIDER_SEND_SEARCH_BOUNDS.timeoutSeconds;
    return intWithin(v.timeoutSeconds, b.min, b.max) ? undefined : 'INVALID_TIMEOUT_SECONDS';
}
/** Whether `lower` only NARROWS `enclosing`: every option it allows, the enclosing layer allows too. */
export function riderSendPaymentNarrows(lower, enclosing) {
    return lower.allowed.every((p) => enclosing.allowed.includes(p));
}
export const RIDER_SEND_PAYMENT_SPEC = {
    key: RIDER_SEND_PAYMENT_KEY,
    issue: riderSendPaymentIssue,
    // The canonical order, so a reviewer approves byte for byte what the version carries.
    copy: (v) => ({ allowed: RIDER_SEND_PAYERS.filter((p) => v.allowed.includes(p)), default: v.default }),
    defaultValue: DEFAULT_RIDER_SEND_PAYMENT,
    strictValue: STRICT_RIDER_SEND_PAYMENT,
    reasonPrefix: 'RIDER_SEND_PAYMENT_POLICY',
    // Who pays the cash is a money control: no lower scope loosens the layers above it.
    constraintClass: 'payment',
    // A deciding value that only narrows the enclosing one stands (its own default is one of its own options); one that would widen it resolves to no
    // rider Send - fail closed, never the wider set, never a silently intersected set the operator did not approve.
    tighten: (deciding, enclosing) => (riderSendPaymentNarrows(deciding, enclosing) ? deciding : { allowed: [], default: null }),
};
export const RIDER_SEND_SEARCH_SPEC = {
    key: RIDER_SEND_SEARCH_KEY,
    issue: riderSendSearchIssue,
    copy: (v) => ({ timeoutSeconds: v.timeoutSeconds }),
    defaultValue: DEFAULT_RIDER_SEND_SEARCH,
    strictValue: STRICT_RIDER_SEND_SEARCH,
    reasonPrefix: 'RIDER_SEND_SEARCH_POLICY',
};
export function riderSendPaymentSetting(input) {
    return marketRuleSetting(RIDER_SEND_PAYMENT_SPEC, input);
}
export function riderSendSearchSetting(input) {
    return marketRuleSetting(RIDER_SEND_SEARCH_SPEC, input);
}
export function resolveRiderSendPayment(settings, marketId, at, regionCode) {
    return resolveMarketRule(RIDER_SEND_PAYMENT_SPEC, settings, marketId, at, regionCode);
}
export function resolveRiderSendSearch(settings, marketId, at, regionCode) {
    return resolveMarketRule(RIDER_SEND_SEARCH_SPEC, settings, marketId, at, regionCode);
}
//# sourceMappingURL=rider-send-policy.js.map